import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PersonalDetail } from '../../Models/Models/Customer/PersonalDetail';

declare var IS_RUNNING_IN_APP_POOL;

export class PersonalDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<PersonalDetail, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/PersonalDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<PersonalDetail, any>(url, data);
  }
  public put(customerId: number, personalDetail: PersonalDetail): Promise<PersonalDetail, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/PersonalDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, personalDetail: personalDetail }

    return AjaxWrapper.put<PersonalDetail, any>(url, data);
  }
}

